import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import { P1, P2, P3, P4, P5, P6 } from '../../assests/ExportImageIcon'

const destinations = [
    { img: P1, name: 'Rajasthan', price: 'From ₹8,999' },
    { img: P2, name: 'Manali', price: 'From ₹8,999' },
    { img: P3, name: 'Goa', price: 'From ₹8,999' },
    { img: P4, name: 'Rishikesh', price: 'From ₹8,999' },
    { img: P5, name: 'Manali', price: 'From ₹8,999' },
    { img: P6, name: 'Goa', price: 'From ₹8,999' },
]

const PopularDestination = ({heading = 'Popular Destinations', showDestinationDetails = true }) => {
    const prevRef = useRef(null)
    const nextRef = useRef(null)
    const swiperRef = useRef(null)

    useEffect(() => {
        const swiper = swiperRef.current
        if (!swiper) return
        swiper.params.navigation = {
            ...swiper.params.navigation,
            prevEl: prevRef.current,
            nextEl: nextRef.current,
        }
        swiper.navigation.init()
        swiper.navigation.update()
    }, [])

    return (
        <>
            <section className='popularDestination paddingCmn'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='secHeadArea'>
                                <div className='mainHead'>{heading}</div>
                                <Link to="/">View All</Link>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="carousel">
                                <Swiper
                                    modules={[Navigation, Autoplay]}
                                    spaceBetween={20}
                                    slidesPerView={1.2}
                                    loop
                                    autoplay={{ delay: 2000, disableOnInteraction: false, pauseOnMouseEnter: true }}
                                    onSwiper={(swiper) => { swiperRef.current = swiper }}
                                    breakpoints={{
                                        576: { slidesPerView: 2 },
                                        768: { slidesPerView: 3 },
                                        992: { slidesPerView: 4 },
                                        1200: { slidesPerView: 5 },
                                    }}
                                >
                                    {destinations.map((destination, index) => (
                                        <SwiperSlide key={index} className="item">
                                            <div className='slidePart'>
                                                <img src={destination.img} alt="Popular Destination" />
                                                {showDestinationDetails && (
                            <>
                                <div className="destinationName">
                                    {destination.name}
                                </div>

                                <div className="destinationPrice">
                                    {destination.price}
                                </div>
                            </>
                        )}
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                                {/* <button type="button" className="carouselNav carouselNav-prev" ref={prevRef} aria-label="Previous">&#8249;</button>
                                <button type="button" className="carouselNav carouselNav-next" ref={nextRef} aria-label="Next">&#8250;</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default PopularDestination
